//@flow
import { arePersonalInfoModified } from './lib';
import { compose } from 'react-recompose';
import { confirmPersonalInfo, hasEditedIdentificationInfo } from '../../../modules/Customer';
import { connect } from 'react-redux';
import { dateUtils } from '../../../lib/date-utils';
import { formActivatePersonalInfoSelector } from '../../../modules/selectors';
import { formValueSelector, reduxForm } from 'redux-form';
import { isLoadingSelector } from '../../../modules/LoadingStatus';
import { setDeliveryContact } from '../../../modules/SignUp/DeliveryContact';
import config from '../../../config';
import ConfirmPersonalInfo from './ConfirmPersonalInfo';
import type { StateProps, DispatchProps, MergeProps } from './ConfirmPersonalInfo';
import validate from './validation';

const mapStateToProps = (state): StateProps => {
  const formSelector = formValueSelector('personalInfo');
  return {
    initialValues: formActivatePersonalInfoSelector(state),
    isLoading: isLoadingSelector(state, 'confirmPersonalInfo'),
    selectedGender: formSelector(state, 'gender'),
  };
};

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  hasEditedIdentificationInfo: () => dispatch(hasEditedIdentificationInfo()),
  confirmPersonalInfo: values => dispatch(confirmPersonalInfo(values)),
  setDeliveryContact: values => {
    config.askPersonalInformationDuringOrderSim &&
      dispatch(
        setDeliveryContact({ name: `${values.givenName} ${values.familyName}`, phoneNumber: values.contactPhoneNumber })
      );
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps): MergeProps => ({
  onSubmit: values => {
    // need to convert expirationDateTime to timestamp if it is in format 'P' (mm/dd/yyyy | dd/mm/yyyy)
    const expirationDateTime = values?.identification?.characteristics?.expirationDateTime;
    if (expirationDateTime && isNaN(Number(expirationDateTime))) {
      values.identification.characteristics.expirationDateTime = dateUtils.parse(expirationDateTime, 'P').getTime();
    }
    if (arePersonalInfoModified(values, stateProps.initialValues)) {
      dispatchProps.hasEditedIdentificationInfo();
    }
    dispatchProps.confirmPersonalInfo({
      ...values,
    });
    dispatchProps.setDeliveryContact(values);
  },
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  reduxForm({ form: 'personalInfo', validate })
);
export default enhance(ConfirmPersonalInfo);
